<template>
  <div class="gameAreaDiv" :class="{gameFill: fillParent}" :style="{
    borderTopLeftRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTopRightRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTop: (isDesktop || HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 4)?'':'1px solid #ccc',
    '--pc-sticky-header-h': (isDesktop && pcStickyHeaderH) ? pcStickyHeaderH + 'px' : '0px',
  }">
    <div class="gameRowWrap" :class="{ gameColWrapPc: isDesktop }" :style="{height: (!isDesktop && fillParent) ? '100%' : undefined}">
      <!-- 分类导航: 移动端竖排在左侧; 桌面横排在游戏区顶部(吸顶) -->
      <div ref="catBarRef" :class="{ catTopBarPc: isDesktop }"
           :style="{width: isDesktop ? '100%' : '76px', height: (!isDesktop && fillParent) ? '100%' : undefined, flexShrink: isDesktop ? 0 : undefined, top: (isDesktop && pcStickyHeaderH) ? pcStickyHeaderH + 'px' : undefined}">
        <div ref="scrollContainerRef" class="leftCategory" :class="{ leftCategoryRowPc: isDesktop }" :style="{height: leftColHeight}">
          <div v-for="(item, index) in leftIconInfo" :key="index">
            <div v-if="HNewGameUIConfig.newGameUIType===4" @click="goSection(index)"
                 :style="{
                    width:'76px',
                    height:'30px',
                    marginBottom:'6px',
                    color:activeIndex === index?'white':'#888',
                    fontSize:'16px',
                    paddingLeft:'6px',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    backgroundImage:activeIndex === index?`url(${iconJmttTitleBg})`:'',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'left',
                 }">
              {{item["name"]}}
            </div>
            <!-- 选中/未选中两张图都立即渲染加载, 用 v-show 切换显示, 切换瞬间选中图已就绪(不会等下载) -->
            <template v-if="HNewGameUIConfig.newGameUIType!==4">
              <HCacheImage v-show="activeIndex === index" @click="goSection(index)" :src="item.icon_press"
                           width="60px" :height="HNewGameUIConfig.newGameUIType === 0 ?'60px':'66px'"
                           style="margin-bottom: 6px;"/>
              <HCacheImage v-show="activeIndex !== index" @click="goSection(index)" :src="item.icon"
                           width="60px" :height="HNewGameUIConfig.newGameUIType === 0 ?'60px':'66px'"
                           style="margin-bottom: 6px;"/>
            </template>
          </div>
          <!-- 底部留白: type0 有底部 tabbar 需避让(+home indicator); 其它样式内嵌无 tabbar, 游戏区到底 -->
          <div :style="{height: HNewGameUIConfig.newGameUIType === 0 ? 'calc(10px + env(safe-area-inset-bottom))' : '12px', flexShrink: 0}"/>
        </div>
      </div>

      <!-- 瀑布流: 所有分类依次平铺, 每个分类前插入分类名分割标题。桌面下移到分类栏下方全宽 -->
      <div :style="{width: isDesktop ? '100%' : 'calc(100% - 76px)', height: (!isDesktop && fillParent) ? '100%' : undefined}">
        <div ref="waterfallRef" class="waterfall" :class="{ waterfallPc: isDesktop }" :style="{height: rightColHeight}"
             @scroll="onWaterfallScroll" @touchstart="onWfTouchStart" @wheel="markUserScroll">
          <div class="waterfall-section" v-for="(page, pIndex) in data" :key="page['Name'] ?? pIndex">
            <!-- 分类名分割标题(复用收藏游戏那种 ---xxx--- 居中样式); “我的”自带最近/收藏子分栏, 不再额外加分类标题 -->
            <div v-if="page['Name'] && page['Name'] !== '我的'" class="sectionTitle">
              <div class="sectionLine"/>
              <div class="sectionDot"/>
              <div :style="hcf.getTextStyle({color:'main',marginRight:5,marginLeft:5,fontWeight:'bold',addSize:1})">{{ page['Name'] }}</div>
              <div class="sectionDot"/>
              <div class="sectionLine"/>
            </div>
            <div class="allRowParent" v-for="eachTemplate in visibleTemplates(page)" :key="eachTemplate['Id']">
              <GameAreaParserTemplate :favoriteCallback="getLobbyData" :eachTemplate="eachTemplate"/>
            </div>
          </div>
          <!-- 底部留白: type0 有底部 tabbar 需避让(+home indicator); 其它样式内嵌无 tabbar, 游戏区到底 -->
          <div :style="{height: HNewGameUIConfig.newGameUIType === 0 ? 'calc(70px + env(safe-area-inset-bottom))' : '12px'}"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import GameAreaParserTemplate from "@/components/pages/home/GameAreaParserTemplate.vue";
  import {ref} from "vue";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {useResponsive} from "@/hooks/useResponsive.js";
  const iconJmttTitleBg = hcf.getNewGameUIIcon("flag_choose.png");
  // 桌面: 分类栏改为横排放在游戏区顶部, 瀑布区在下方全宽
  const {isDesktop} = useResponsive();

  const props = defineProps({
    bottomContainerHeight: {type: Number, default: 0},
    // true: 高度交给 flex 撑满父容器(永利首页, 避免 px 测量漂移导致整页溢出)
    fillParent: {type: Boolean, default: false},
  });
  let useHttp = useHHttp();

  // 左右两列高度: fillParent 时用 100% 减去各自 margin-top(左 10px / 右 11px), 保证含外边距后正好填满父高、不溢出
  const leftColHeight = computed(() => {
    if (isDesktop.value) return 'auto'; // 桌面横排, 高度由内容决定
    return props.fillParent ? 'calc(100% - 10px)' : props.bottomContainerHeight + 'px';
  });
  const rightColHeight = computed(() => {
    if (isDesktop.value) return 'auto'; // 桌面: 瀑布自然高度, 不内部滚动, 跟随整页一起滚
    return props.fillParent ? 'calc(100% - 11px)' : props.bottomContainerHeight + 'px';
  });

  // 当前高亮的分类(由点击或滚动同步)
  const activeIndex = ref(0);
  const scrollContainerRef = ref();   // 左侧分类列
  const waterfallRef = ref();          // 右侧瀑布滚动容器
  const catBarRef = ref();             // 桌面: 顶部吸顶分类栏(用其底边作 scroll-spy 判定线)
  // 桌面(非 main 包网): 头部块(公告+余额/充值/提现行)也吸顶, 分类栏要落在其下方,
  // 故测出该吸顶头部高度, 作为分类栏 sticky 的 top 偏移。
  const pcStickyHeaderH = ref(0);
  let pcHeaderRO = null;
  function measurePcStickyHeader() {
    if (!isDesktop.value) { pcStickyHeaderH.value = 0; return; }
    const h = document.querySelector('.pcStickyHeader');
    pcStickyHeaderH.value = h ? Math.round(h.getBoundingClientRect().height) : 0;
  }

  let data = ref([]);
  let leftIconInfo = ref([]);

  // 滚动联动时把左侧高亮图标滚到列中间
  function scrollToCenter(index, isAnimate = true) {
    if (!scrollContainerRef.value) return;
    const targetYValue = 60 * index - 90;
    if (isAnimate) {
      scrollContainerRef.value.scrollTo({top: targetYValue, behavior: 'smooth'});
    } else {
      scrollContainerRef.value.scrollTop = targetYValue;
    }
  }

  function setActive(index) {
    if (index === activeIndex.value) return;
    activeIndex.value = index;
    scrollToCenter(index);
  }

  // 左侧 scroll-spy 仅在用户主动滑动/滚轮时跟随; 点击分类触发的程序滚动期间不跟随(避免来回跳)
  let userScrolling = false;
  function markUserScroll() { userScrolling = true; }

  // 固定时长的缓动滚动(取代原生 smooth: 原生时长随距离变化, 远距离会很慢)
  let scrollAnimId = null;
  const SCROLL_DURATION = 280; // ms, 不论远近都用同一时间
  function animateScrollTo(cont, to) {
    if (scrollAnimId) cancelAnimationFrame(scrollAnimId);
    const start = cont.scrollTop;
    const change = to - start;
    if (Math.abs(change) < 1) { cont.scrollTop = to; return; }
    const ease = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2); // easeInOutCubic
    let startTs = null;
    function step(ts) {
      if (startTs === null) startTs = ts;
      const t = Math.min(1, (ts - startTs) / SCROLL_DURATION);
      cont.scrollTop = start + change * ease(t);
      scrollAnimId = t < 1 ? requestAnimationFrame(step) : null;
    }
    scrollAnimId = requestAnimationFrame(step);
  }

  // 点击左侧分类: 固定时长滚动右侧到对应分类锚点; 关闭跟随, 左侧固定停在点击的分类
  function goSection(index) {
    const cont = waterfallRef.value;
    if (!cont) return;
    const sections = cont.querySelectorAll('.waterfall-section');
    const target = sections[index];
    if (!target) return;
    // 桌面: 实际滚动容器是外层页面(tabScrollArea), 瀑布本身不内部滚动;
    // 用 scrollIntoView 让最近可滚动祖先滚到该分类(配合 section 的 scroll-margin-top 避开吸顶分类栏)。
    if (isDesktop.value) {
      activeIndex.value = index;
      // 程序平滑滚动期间关闭 scroll-spy, 避免途中把高亮抢到中间分类; 滚动结束后恢复跟随
      spySuppressUntil = Date.now() + 700;
      scrollCatIntoViewH(index);
      target.scrollIntoView({behavior: 'smooth', block: 'start'});
      return;
    }
    userScrolling = false;
    activeIndex.value = index;
    scrollToCenter(index);
    // 用相对容器顶部的距离(不依赖 offsetParent), 基准与 scrollTop 一致, 定位才准
    const targetTop = target.getBoundingClientRect().top - cont.getBoundingClientRect().top + cont.scrollTop;
    animateScrollTo(cont, targetTop);
  }

  // 滚动联动(scroll-spy): 找到顶部越过判定线的最后一个分类; 滚到底部时强制高亮最后一个。
  function onWaterfallScroll() {
    if (!userScrolling) return;
    const cont = waterfallRef.value;
    if (!cont) return;
    const sections = cont.querySelectorAll('.waterfall-section');
    if (!sections.length) return;
    if (cont.scrollTop + cont.clientHeight >= cont.scrollHeight - 2) {
      setActive(sections.length - 1);
      return;
    }
    // 判定线: section 顶部相对容器顶 <= 70px 视为已进入(与 goSection 同一套 rect 基准)
    const contTop = cont.getBoundingClientRect().top;
    let active = 0;
    for (let i = 0; i < sections.length; i++) {
      const rel = sections[i].getBoundingClientRect().top - contTop;
      if (rel <= 70) active = i; else break;
    }
    setActive(active);
  }

  // 边界外溢拦截: 瀑布滚到顶/到底后, 手指继续朝边缘方向拖时阻止默认, 否则会带动整个首页一起滚动。
  // 项目全局启用了 default-passive-events, Vue 的 @touchmove 是被动监听无法 preventDefault,
  // 故 touchmove 用非被动监听手动绑定(见 onMounted)。
  let wfTouchStartY = 0;
  function onWfTouchStart(e) {
    wfTouchStartY = e.touches[0].clientY;
    userScrolling = true;
    // 用户在动画途中触摸: 立即停止程序滚动, 交还控制权
    if (scrollAnimId) { cancelAnimationFrame(scrollAnimId); scrollAnimId = null; }
  }
  function onWfTouchMove(e) {
    const el = waterfallRef.value;
    if (!el) return;
    const dy = e.touches[0].clientY - wfTouchStartY; // >0 下拉 / <0 上滑
    const atTop = el.scrollTop <= 0;
    const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    if (((dy < 0 && atBottom) || (dy > 0 && atTop)) && e.cancelable) {
      e.preventDefault();
    }
  }

  // ===== 桌面 scroll-spy =====
  // 桌面瀑布不内部滚动(overflow visible), 真正滚动的是外层页面容器(tabScrollArea)。
  // 故在此监听最近的可滚动祖先, 按各分类分栏相对吸顶分类栏底边的位置, 高亮当前分类。
  let spyTarget = null;               // 实际监听滚动的元素
  let spySuppressUntil = 0;           // 点击分类后的程序滚动期间, 暂不做 spy 抢高亮(避免途中来回跳)

  function findScrollParent(el) {
    let p = el?.parentElement;
    while (p) {
      const oy = getComputedStyle(p).overflowY;
      if (oy === 'auto' || oy === 'scroll') return p; // 内容未加载时高度可能不足, 不按当前可滚动性判断
      p = p.parentElement;
    }
    return null;
  }

  // 把当前高亮分类横向滚进可视区(桌面分类栏是横排)
  function scrollCatIntoViewH(index) {
    const cont = scrollContainerRef.value;
    const child = cont?.children?.[index];
    if (!cont || !child) return;
    const cl = cont.getBoundingClientRect();
    const chl = child.getBoundingClientRect();
    if (chl.left < cl.left + 4 || chl.right > cl.right - 4) {
      const delta = (chl.left - cl.left) - (cl.width - chl.width) / 2;
      cont.scrollTo({ left: cont.scrollLeft + delta, behavior: 'smooth' });
    }
  }

  function onDesktopSpy() {
    if (Date.now() < spySuppressUntil) return;
    const wf = waterfallRef.value;
    const sections = wf?.querySelectorAll('.waterfall-section');
    if (!sections || !sections.length) return;
    let active;
    // 滚到底: 强制高亮最后一个(否则最后一个分栏可能永远越不过判定线)
    const sp = spyTarget;
    if (sp && sp.scrollTop + sp.clientHeight >= sp.scrollHeight - 2) {
      active = sections.length - 1;
    } else {
      const line = catBarRef.value ? catBarRef.value.getBoundingClientRect().bottom : 0;
      active = 0;
      for (let i = 0; i < sections.length; i++) {
        if (sections[i].getBoundingClientRect().top - line <= 8) active = i; else break;
      }
    }
    if (active !== activeIndex.value) {
      activeIndex.value = active;
      scrollCatIntoViewH(active);
    }
  }

  // 过滤掉空的“收藏游戏”模块: 无任何收藏时不显示收藏分栏(也就没有“暂无收藏”提示)
  function visibleTemplates(page) {
    const tl = page['TemplateList'] ?? [];
    return tl.filter(t => !(t && t['Title'] === '收藏游戏' && (t['ItemList']?.length ?? 0) === 0));
  }

  function getLobbyData() {
    useHttp.request("/qp/game/lobby", (respData) => {
      leftIconInfo.value = [];
      data.value = respData.Data;
      for (let each of data.value) {
        leftIconInfo.value.push({
          "icon": each["Icon2"],
          'icon_press': each["Icon1"],
          'name': each['Name'],
        });
      }
    }, {isShowLoading: false})
  }

  onActivated(() => {
    scrollToCenter(activeIndex.value, false);
  });

  onMounted(() => {
    emitter.on("REFRESH_HOME_LOBBY_LIST", () => {
      getLobbyData();
    });
    getLobbyData();
    if (waterfallRef.value) {
      waterfallRef.value.addEventListener('touchmove', onWfTouchMove, {passive: false});
    }
    // 桌面: 瀑布不内部滚动, 在最近的可滚动祖先(tabScrollArea)上挂 scroll-spy
    if (isDesktop.value) {
      requestAnimationFrame(() => {
        // tabScrollArea 是首页在桌面下唯一的滚动容器; 兜底再按 overflow 向上找, 最后退到 window
        spyTarget = waterfallRef.value?.closest('.tabScrollArea')
            || findScrollParent(waterfallRef.value) || window;
        spyTarget.addEventListener('scroll', onDesktopSpy, {passive: true});
        onDesktopSpy();
        // 测量吸顶头部高度作为分类栏 top 偏移; 头部高度可能随登录态/渲染变化, 用 ResizeObserver 跟随
        measurePcStickyHeader();
        const headerEl = document.querySelector('.pcStickyHeader');
        if (headerEl && typeof ResizeObserver !== 'undefined') {
          pcHeaderRO = new ResizeObserver(() => measurePcStickyHeader());
          pcHeaderRO.observe(headerEl);
        }
      });
      window.addEventListener('resize', measurePcStickyHeader);
    }
  });

  onUnmounted(() => {
    if (scrollAnimId) { cancelAnimationFrame(scrollAnimId); scrollAnimId = null; }
    if (waterfallRef.value) {
      waterfallRef.value.removeEventListener('touchmove', onWfTouchMove);
    }
    if (spyTarget) {
      spyTarget.removeEventListener('scroll', onDesktopSpy);
      spyTarget = null;
    }
    if (pcHeaderRO) { pcHeaderRO.disconnect(); pcHeaderRO = null; }
    window.removeEventListener('resize', measurePcStickyHeader);
  });
</script>


<style scoped>
  .leftCategory {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .gameAreaDiv {
    display: flex;
    flex-direction: row;
    background-color: white;
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  /* 永利首页: 游戏区作为 flex 项填满父剩余高度, 内部两列再各自滚动 */
  .gameFill {
    flex: 1;
    min-height: 0;
  }

  .gameRowWrap {
    display: flex;
    width: 100%;
  }

  /* 右侧瀑布滚动容器 */
  .waterfall {
    margin-top: 11px;
    position: relative;
    overflow-y: auto;
    overscroll-behavior: none;
    -webkit-overflow-scrolling: touch;
  }

  .waterfall-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 6px;
  }

  .allRowParent {
    display: flex;
    flex-direction: row;
  }

  /* 分类名分割标题 */
  .sectionTitle {
    width: 100%;
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .sectionLine {
    border-radius: 5px;
    width: 60px;
    height: 1px;
    background-color: var(--ct-main-color);
    opacity: 0.35;
  }

  .sectionDot {
    border-radius: 10px;
    width: 5px;
    height: 5px;
    border: 2px solid var(--ct-main-color);
    opacity: 0.55;
  }

  /* ===== 桌面: 分类栏横排放到游戏区顶部, 瀑布区在下方全宽 ===== */
  @media (min-width: 1024px) {
    /* 上下堆叠: 顶部分类栏 + 下方瀑布 */
    .gameColWrapPc {
      flex-direction: column;
    }

    /* 分类栏容器: 吸顶(随页面滚动固定在游戏区顶部) */
    .catTopBarPc {
      position: sticky;
      top: 0;
      z-index: 6;
      background: var(--ct-main-container-bg-color, #fff);
    }

    /* 点击分类跳转时, 让分类锚点落在吸顶栏下方(避免被遮挡)。非 main 包网头部也吸顶时,
       再加上头部高度(--pc-sticky-header-h, 由 JS 测量), 保证锚点落在 头部+分类栏 下方。 */
    .waterfall-section {
      scroll-margin-top: calc(var(--pc-sticky-header-h, 0px) + 96px);
    }

    /* 分类栏: 横向一行, 顶部, 可横向滚动 */
    .leftCategoryRowPc {
      flex-direction: row !important;
      align-items: center !important;
      justify-content: center;
      width: 100%;
      margin-top: 0;
      padding: 10px 8px;
      gap: 10px;
      overflow-x: auto;
      overflow-y: hidden;
    }

    /* 每个分类项不压缩, 去掉竖排时的底部间距 */
    .leftCategoryRowPc > div {
      flex: 0 0 auto;
    }
    .leftCategoryRowPc :deep(.van-image),
    .leftCategoryRowPc :deep(img) {
      margin-bottom: 0 !important;
    }

    /* 瀑布容器: 顶部分类栏下方, 去掉左列布局遗留的上边距;
       桌面不再内部滚动(overflow visible + auto 高度), 内容自然流入整页, 只保留一套页面滚动 */
    .waterfallPc {
      margin-top: 0;
      overflow: visible;
    }

    /* 桌面: 取消移动端"填满一屏+内部滚动"模型, 游戏区按内容自然高度跟随整页滚动 */
    .gameFill {
      flex: none;
      min-height: auto;
    }

    /* 分类标题的小圆点/短线: <style> 里的 5px/1px 被转 vw(桌面放大), 拉回真实 px */
    .sectionDot {
      width: 5px;
      height: 5px;
      border-width: 2px;
      border-radius: 10px;
    }
    .sectionLine {
      width: 60px;
      height: 1px;
      border-radius: 5px;
    }
  }
</style>
